import React from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import isValidTokenAdmin from './isValidTokenAdmin';

const RequireAdmin = ({ children }) => {
    return isValidTokenAdmin() ? (
        children
    ) : (
        <Navigate to="/dashboard/operator/submitted-abstract" replace />
    );
};

RequireAdmin.propTypes = {
    children: PropTypes.any,
};

export default RequireAdmin;
